import { Component } from '@angular/core';

import { CancelOrderComponent, OrderAmendService } from '@spartacus/order/components';
import { EfaCancelOrReturnItemsComponent } from '../efa-cancel-or-return-items/efa-cancel-or-return-items.component';
import { NgTemplateOutlet, AsyncPipe } from '@angular/common';
import { EfaAmendOrderActionsComponent } from '../efa-amend-order-actions/efa-amend-order-actions.component';

@Component({
    selector: 'app-efa-cancel-order',
    templateUrl: './efa-cancel-order.component.html',
    imports: [EfaCancelOrReturnItemsComponent, NgTemplateOutlet, EfaAmendOrderActionsComponent, AsyncPipe]
})
export class EfaCancelOrderComponent extends CancelOrderComponent {

  constructor(protected orderAmendService: OrderAmendService) {
    super(orderAmendService);
  }
}
